/**
 * PostHog Service Types and Interfaces
 */

export interface PosthogConfig {
  apiKey: string;
  apiHost?: string;
  disabled?: boolean;
  debug?: boolean;
}

export interface PosthogUser {
  id: string;
  email?: string;
  role?: string;
  officeId?: string;
  name?: string;
  subscriptionTier?: string;
}

export interface PosthogEventProperties {
  [key: string]: any;
}

// Redux Action Types
export enum PosthogActionTypes {
  INIT_POSTHOG = 'POSTHOG/INIT',
  TRACK_EVENT = 'POSTHOG/TRACK_EVENT',
  IDENTIFY_USER = 'POSTHOG/IDENTIFY_USER',
  RESET_USER = 'POSTHOG/RESET_USER',
  SET_USER_PROPERTIES = 'POSTHOG/SET_USER_PROPERTIES',
  PAGE_VIEW = 'POSTHOG/PAGE_VIEW',
}

// Redux Action Interfaces
export interface InitPosthogAction {
  type: typeof PosthogActionTypes.INIT_POSTHOG;
  payload: PosthogConfig;
}

export interface TrackEventAction {
  type: typeof PosthogActionTypes.TRACK_EVENT;
  payload: {
    event: string;
    properties?: PosthogEventProperties;
  };
}

export interface IdentifyUserAction {
  type: typeof PosthogActionTypes.IDENTIFY_USER;
  payload: PosthogUser;
}

export interface ResetUserAction {
  type: typeof PosthogActionTypes.RESET_USER;
}

export interface SetUserPropertiesAction {
  type: typeof PosthogActionTypes.SET_USER_PROPERTIES;
  payload: Record<string, any>;
}

export interface PageViewAction {
  type: typeof PosthogActionTypes.PAGE_VIEW;
  payload: {
    path: string;
    properties?: PosthogEventProperties;
  };
}

export type PosthogAction =
  | InitPosthogAction
  | TrackEventAction
  | IdentifyUserAction
  | ResetUserAction
  | SetUserPropertiesAction
  | PageViewAction;